// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ****Fonts**** */
/* ****Shadows (subtle elevation — flat SaaS)**** */
/* ****Border radius**** */
/* ****icon size**** */
/* **** Device width **** */
/* **** helper variable **** */
/* **** Motion **** */
.Button_btn__I1Ey8 {
  font: inherit;
  font-weight: 600;
  border-radius: 8px;
  padding: 0.85rem 1.75rem;
  min-height: 44px;
  cursor: pointer;
  margin: 0;
  transition: background-color 150ms cubic-bezier(0.16, 1, 0.3, 1), transform 150ms cubic-bezier(0.16, 1, 0.3, 1), box-shadow 150ms cubic-bezier(0.16, 1, 0.3, 1);
}

.Button_button__vjwRP {
  border: none;
  background: var(--primaryColor);
  color: #ffffff;
  box-shadow: var(--shadow-sm);
}
.Button_button__vjwRP:hover:not(:disabled), .Button_button__vjwRP:active:not(:disabled) {
  background-color: var(--accentColor);
}
.Button_button__vjwRP:active:not(:disabled) {
  transform: translateY(1px);
}
.Button_button__vjwRP:focus-visible {
  outline: 2px solid var(--ring-color);
  outline-offset: 2px;
}

.Button_outline__qBUUH {
  background-color: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-color);
  box-shadow: none;
}
.Button_outline__qBUUH:hover:not(:disabled) {
  background-color: var(--surface-muted);
  border-color: var(--text-muted);
}

html[dir=rtl] .Button_btn__I1Ey8 {
  font-family: iranyekan, "IRANSans", "Tahoma";
}`, "",{"version":3,"sources":["webpack://./src/components/UI/button/Button.module.scss","webpack://./src/scss/abstracts/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,kBAAA;AAeA,mDAAA;AAIA,0BAAA;AAKA,sBAAA;AAIA,2BAAA;AAMA,8BAAA;AAOA,qBAAA;ADvCA;EACE,aAAA;EACA,gBAAA;EACA,kBCekB;EDdlB,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,+JAAA;AAOF;;AAHA;EACE,YAAA;EACA,+BAAA;EACA,cAAA;EACA,4BAAA;AAMF;AAJE;EAEE,oCAAA;AAKJ;AAFE;EACE,0BAAA;AAIJ;AADE;EACE,oCAAA;EACA,mBAAA;AAGJ;;AACA;EACE,6BAAA;EACA,qCAAA;EACA,wBAAA;EACA,gBAAA;AAEF;AAAE;EACE,sCAAA;EACA,+BAAA;AAEJ;;AAGE;EACE,4CAAA;AAAJ","sourcesContent":["@use \"../../../scss/abstracts/index\" as *;\r\n\r\n.btn {\r\n  font: inherit;\r\n  font-weight: 600;\r\n  border-radius: $smallBorderRadius;\r\n  padding: 0.85rem 1.75rem;\r\n  min-height: 44px;\r\n  cursor: pointer;\r\n  margin: 0;\r\n  transition: background-color $duration-fast $ease-out, transform $duration-fast $ease-out,\r\n    box-shadow $duration-fast $ease-out;\r\n}\r\n\r\n.button {\r\n  border: none;\r\n  background: var(--primaryColor);\r\n  color: #ffffff;\r\n  box-shadow: var(--shadow-sm);\r\n\r\n  &:hover:not(:disabled),\r\n  &:active:not(:disabled) {\r\n    background-color: var(--accentColor);\r\n  }\r\n\r\n  &:active:not(:disabled) {\r\n    transform: translateY(1px);\r\n  }\r\n\r\n  &:focus-visible {\r\n    outline: 2px solid var(--ring-color);\r\n    outline-offset: 2px;\r\n  }\r\n}\r\n\r\n.outline {\r\n  background-color: transparent;\r\n  border: 1px solid var(--border-color);\r\n  color: var(--text-color);\r\n  box-shadow: none;\r\n\r\n  &:hover:not(:disabled) {\r\n    background-color: var(--surface-muted);\r\n    border-color: var(--text-muted);\r\n  }\r\n}\r\n\r\nhtml[dir=\"rtl\"] {\r\n  .btn {\r\n    font-family: iranyekan, \"IRANSans\", \"Tahoma\";\r\n  }\r\n}\r\n","/* ****Fonts**** */\r\n\r\n//Body size\r\n$fontSizeBodySmall: 12px;\r\n$fontSizeBodyMedium: 14px;\r\n$fontSizeBodyLarge: 16px;\r\n//Headline size\r\n$fontSizeHeadlineSmall: 24px;\r\n$fontSizeHeadlineMedium: 36px;\r\n$fontSizeHeadlineLarge: 48px;\r\n//Display size\r\n$fontSizeDisplaySmall: 56px;\r\n//helper font size\r\n$fontSizeTableStatus: 11px;\r\n\r\n/* ****Shadows (subtle elevation — flat SaaS)**** */\r\n$mainBoxShadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);\r\n$secondBoxShadow: 0 12px 40px rgba(15, 23, 42, 0.18);\r\n\r\n/* ****Border radius**** */\r\n$smallBorderRadius: 8px;\r\n$mediumBorderRadius: 12px;\r\n$largeBorderRadius: 16px;\r\n\r\n/* ****icon size**** */\r\n$smallIconSize: 20px;\r\n$largeIconSize: 48px;\r\n\r\n/* **** Device width **** */\r\n$mobile-width: 576px;\r\n$tablet-width: 768px;\r\n$desktop-width: 992px;\r\n$largeDesktop-width: 1200px;\r\n\r\n/* **** helper variable **** */\r\n$sideBarOpenWidth: 248px;\r\n$sideBarCloseWidth: 72px;\r\n$spacing: 60px;\r\n$mobileSpacing: 16px;\r\n$sideBarLogoHeight: 171px;\r\n\r\n/* **** Motion **** */\r\n$ease-out: cubic-bezier(0.16, 1, 0.3, 1);\r\n$duration-fast: 150ms;\r\n$duration-base: 200ms;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `Button_btn__I1Ey8`,
	"button": `Button_button__vjwRP`,
	"outline": `Button_outline__qBUUH`
};
export default ___CSS_LOADER_EXPORT___;
